module.exports = __webpack_public_path__ + "static/media/student skills.76c68a4c.svg";